/*global google*/
import React from 'react';
import axios from "axios";
import Select, { components } from "react-select";
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSidebarMnt';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";

const INDIVIDUAL_CRM_SURVEY_SEARCH_KEY = 'mntIndividualCrmSurveySearch';

const IndividualCrmSurvey = () => {
    const navigate = useNavigate();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState('');
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState('');
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [selectedFinYear, setSelectedFinYear] = useState('All');
    const [finYear, setFinYear] = useState('');
    // searchRequest drives React Query fetch; null = no search yet
    const [searchRequest, setSearchRequest] = useState(null);
    // validation error shown before submit (separate from API errors)
    const [validationMsg, setValidationMsg] = useState('');
    const [isStateFrozen, setIsStateFrozen] = useState(false);
    const [isDistrictFrozen, setIsDistrictFrozen] = useState(false);
    const [isUserTypeFrozen, setIsUserTypeFrozen] = useState(false);
    const [desiredDistrictCode, setDesiredDistrictCode] = useState(null);
    const [isStateOrDistrictUser, setIsStateOrDistrictUser] = useState(false);
    const hasCalledStateUserApi = useRef(false);
    const [expImplementsByBeneficiary, setExpImplementsByBeneficiary] = useState({});

    // Modal states for implements
    const [showImplementsModal, setShowImplementsModal] = useState(false);
    const [selectedImplements, setSelectedImplements] = useState(null);
    const [loadingImplements, setLoadingImplements] = useState(false);
    const [implementsModalError, setImplementsModalError] = useState(null);
    
    // Modal states for polygon
    const [showPolygonModal, setShowPolygonModal] = useState(false);
    const [selectedPolygon, setSelectedPolygon] = useState(null);
    const [polygonMap, setPolygonMap] = useState(null);

    // Modal states for beneficiary detail
    const [showBenModal, setShowBenModal] = useState(false);
    const [selectedBenData, setSelectedBenData] = useState(null);
    const [loadingBen, setLoadingBen] = useState(false);
    const [benModalError, setBenModalError] = useState(null);
    
    // Prevent duplicate API calls
    const beneficiaryApiCallInProgress = useRef(false);
    const implementsApiCallInProgress = useRef(false);
    const skipAutoFetchRef = useRef(false);
   // const [finYears, setFinYears] = useState([]);
 //const [selectedFinYear, setSelectedFinYear] = useState("All");
    
    // Keep same loader options across pages to avoid
    // "Loader must not be called again with different options" crash.
    const mapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
        || "AIzaSyD4X4kzlpReymgcXUXGh0Q3TalmxJmasM0";
    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: mapsApiKey,
    });
    
    // State to track if search has been performed
    const [hasSearched, setHasSearched] = useState(false);
    // Track whether search was triggered via Submit button
    const [isManualSearch, setIsManualSearch] = useState(false);
    
    // Key to force Select components to re-render when cleared
    const [selectKey, setSelectKey] = useState(0);
    
    // State for user type selection (temporary - changes on dropdown)
    const [selectedUserType, setSelectedUserType] = useState(null);
    // State for applied user type (used for table columns - only updates on Submit)
    const [appliedUserType, setAppliedUserType] = useState(null);
    
    // User type options
    const userTypeOptions = [
        // { value: '1', label: 'FMTTI' },
        { value: '2', label: 'CRM' },
        { value: '3', label: 'SMAM' }
    ];

    // SMAM/CRM login par sirf apna scheme dikhe; central admin ko dono dikhenge
    const loggedInSchemeType = sessionStorage.getItem("userTypeCodeModel");
    const loggedInUserRole = sessionStorage.getItem("userRoleCodeModel");
    const availableUserTypeOptions = (() => {
        // State/District login + CRM user: dono option (CRM & SMAM)
        if ((loggedInUserRole === '2' || loggedInUserRole === '3') && loggedInSchemeType === '2') {
            return userTypeOptions;
        }
        if (loggedInSchemeType === '3') {
            return userTypeOptions.filter(opt => opt.value === '3');
        }
        if (loggedInSchemeType === '2') {
            return userTypeOptions.filter(opt => opt.value === '2');
        }
        return userTypeOptions;
    })();

    // CRM ke liye sirf 5 states allowed hain
    const CRM_ALLOWED_STATES = ['Delhi', 'Haryana', 'Madhya Pradesh', 'Punjab', 'Uttar Pradesh'];

    const filteredStateOptions = selectedUserType === '2'
        ? optionState.filter(opt => CRM_ALLOWED_STATES.includes(opt.label))
        : optionState;

    // table utilities: sorting and pagination
    const [sortKey, setSortKey] = useState('');
    const [sortDir, setSortDir] = useState('asc'); // 'asc' | 'desc'
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    const baseUrl = process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE;
    const queryClient = useQueryClient();

    // ── React Query: survey data fetch ───────────────────────────────────────
    const {
        data: queryData,
        isLoading,
        error: queryError,
    } = useQuery({
        queryKey: ['individualCrmSurvey', searchRequest?.params, searchRequest?.requestId],
        queryFn: async ({ queryKey }) => {
            const params = queryKey[1];
            const res = await axios.post(
                `${baseUrl}/api/MT/INdividualSurveyDetail`,
                params,
                { headers: { 'Content-Type': 'application/json', accept: '*/*' } }
            );
            const content = res?.data?.dataContent ?? [];
            return Array.isArray(content) ? content : [];
        },
        enabled: searchRequest !== null,
        staleTime: 5 * 60 * 1000,   // 5 min tak same filters ka result cache se milega
        gcTime:    10 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
    });

    // Derived values — used throughout component like the old state variables
    const rows         = queryData ?? [];
    const loading      = isLoading;
    const errorMessage = queryError
        ? 'Unable to fetch survey data. Please check your connection and try again. If the problem persists, contact your administrator.'
        : '';

    const [finYears, setFinYears] = useState(() => {
          const currentYear = new Date().getFullYear();
          const years = ["All"];
      
          // Add last 5 financial years
          for (let i = 0; i < 16; i++) {
            const startYear = currentYear - i;
            const endYear = startYear + 1;
            years.push(`${startYear}-${endYear}`);
          }
      
          return years;
        });
        useEffect(() => {
    fetchFinancialYears();
}, []);

const fetchFinancialYears = async () => {
    try {
        const response = await axios.get(
            `${baseUrl}/api/ExpensiveMachinery/GetMasterFInancialYear`,
            {
                headers: {
                    accept: "*/*"
                }
            }
        );

        console.log("Financial Years:", response.data);

        const years = response.data?.dataContent || [];

        setFinYears(years);
    } catch (error) {
        console.error("Error fetching financial years:", error);
    }
};
    const persistSearchState = (overrides = {}) => {
        try {
            const snapshot = {
                selectedUserType,
                appliedUserType,
                selectedFinYear,
                finYear,
                stateValue,
                districtValue,
                subdistrictValue,
                villageValue,
                selectedDataSetDistrict,
                selectedDataSetSubDistrict,
                selectedDataSetVillage,
                hasSearched,
                isManualSearch,
                currentPage,
                pageSize,
                sortKey,
                sortDir,
                searchRequest,
                ...overrides,
            };
            sessionStorage.setItem(INDIVIDUAL_CRM_SURVEY_SEARCH_KEY, JSON.stringify(snapshot));
        } catch (e) {
            console.warn('Unable to persist survey search state', e);
        }
    };

    const readPersistedSearchState = () => {
        try {
            const raw = sessionStorage.getItem(INDIVIDUAL_CRM_SURVEY_SEARCH_KEY);
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    };

    const clearPersistedSearchState = () => {
        sessionStorage.removeItem(INDIVIDUAL_CRM_SURVEY_SEARCH_KEY);
    };

    function restoreDependentFilters(saved) {
        if (!saved?.stateValue?.length) return;

        const stateCode = String(saved.stateValue[0]);
        const districtCode = saved.districtValue ? String(saved.districtValue) : '';
        const subDistrictCode = saved.subdistrictValue ? String(saved.subdistrictValue) : '';

        const jsonHeaders = { method: 'POST', headers: { 'Content-Type': 'application/json' }, redirect: 'follow' };

        fetch(`${baseUrl}/api/district`, {
            ...jsonHeaders,
            body: JSON.stringify({ stateCode }),
        })
            .then((response) => response.text())
            .then((result) => {
                let localFormDataDistrict = JSON.parse(result).dataContent || [];
                const userRole = sessionStorage.getItem('userRoleCodeModel');
                const assignedDistricts = sessionStorage.getItem('districtCodeModel');
                if (userRole === '3' && assignedDistricts) {
                    const assignedDistrictCodes = String(assignedDistricts).split(',').map((code) => code.trim());
                    localFormDataDistrict = localFormDataDistrict.filter((item) =>
                        assignedDistrictCodes.includes(String(item.districtCode))
                    );
                }
                setOptionDistrict(
                    localFormDataDistrict.map((item) => ({
                        label: item.districtName,
                        value: item.districtCode,
                        stateid: item.stateCode,
                    }))
                );

                if (!districtCode) return null;
                return fetch(`${baseUrl}/api/subdistrict`, {
                    ...jsonHeaders,
                    body: JSON.stringify({ stateCode, districtCode }),
                });
            })
            .then((response) => (response ? response.text() : null))
            .then((result) => {
                if (!result) return null;
                const localFormDataSubDistrict = JSON.parse(result).dataContent || [];
                setOptionSubDistrict(
                    localFormDataSubDistrict.map((item) => ({
                        label: item.subDistrictName,
                        value: item.subDistrictCode,
                        districtCode: item.districtCode,
                    }))
                );

                if (!subDistrictCode) return null;
                return fetch(`${baseUrl}/api/village`, {
                    ...jsonHeaders,
                    body: JSON.stringify({
                        stateCode,
                        districtCode: districtCode || '0',
                        subDistrictCode,
                    }),
                });
            })
            .then((response) => (response ? response.text() : null))
            .then((result) => {
                if (!result) return;
                const localFormDataVillage = JSON.parse(result).dataContent || [];
                setOptionVillage(
                    localFormDataVillage.map((item) => ({
                        label: item.villageName,
                        value: item.villageCode,
                        subDistrictCode: item.subDistrictCode,
                    }))
                );
            })
            .catch((error) => console.log('error restoring geo filters', error));
    }

    useEffect(() => {
        getStates();
        // Prefill and freeze based on user type (State/District)
        const userType = sessionStorage.getItem("userRoleCodeModel");
      //  alert(userType);
        // Some logins stored state code under stateNameModel; use it as fallback
        const stateCodeStr = sessionStorage.getItem("stateCodeModel") || sessionStorage.getItem("stateNameModel");
        // Try multiple session storage keys for district information
        const districtCodeStr = sessionStorage.getItem("districtCodeModel") || sessionStorage.getItem("districtNameModel");
        const userTypeCodeModel = sessionStorage.getItem("userTypeCodeModel");
        const saved = readPersistedSearchState();
        const hasSavedSearch = Boolean(saved?.searchRequest || saved?.hasSearched);

        // SMAM/CRM login: always pre-select and freeze User Type
        if (userTypeCodeModel === '3') {
            setSelectedUserType(userTypeCodeModel);
            setAppliedUserType(userTypeCodeModel);
            setIsUserTypeFrozen(true);
        }

        if (hasSavedSearch) {
            skipAutoFetchRef.current = true;
            if (userTypeCodeModel !== '3') {
                if (saved.selectedUserType) setSelectedUserType(saved.selectedUserType);
                if (saved.appliedUserType) setAppliedUserType(saved.appliedUserType);
            }
            if (saved.selectedFinYear) setSelectedFinYear(saved.selectedFinYear);
            if (saved.finYear !== undefined) setFinYear(saved.finYear);
            if (saved.stateValue?.length) setStateValue(saved.stateValue);
            if (saved.districtValue !== undefined) setDistrictValue(saved.districtValue);
            if (saved.subdistrictValue !== undefined) setsubDistrictValue(saved.subdistrictValue);
            if (saved.villageValue !== undefined) setvillageValue(saved.villageValue);
            if (saved.selectedDataSetDistrict !== undefined) setselectedDataSetDistrict(saved.selectedDataSetDistrict);
            if (saved.selectedDataSetSubDistrict !== undefined) setselectedDataSetSubDistrict(saved.selectedDataSetSubDistrict);
            if (saved.selectedDataSetVillage !== undefined) setselectedDataSetVillage(saved.selectedDataSetVillage);
            setHasSearched(Boolean(saved.hasSearched));
            setIsManualSearch(Boolean(saved.isManualSearch));
            if (saved.currentPage) setCurrentPage(saved.currentPage);
            if (saved.pageSize) setPageSize(saved.pageSize);
            if (saved.sortKey !== undefined) setSortKey(saved.sortKey);
            if (saved.sortDir) setSortDir(saved.sortDir);
            if (saved.searchRequest) setSearchRequest(saved.searchRequest);
        }
        
        if (userType === "2" && stateCodeStr) { // State login
            const sc = Number(stateCodeStr);
            if (!hasSavedSearch) setStateValue([sc]);
            setIsStateFrozen(true);
            setIsStateOrDistrictUser(true);
            if (hasSavedSearch) {
                restoreDependentFilters(saved);
            } else {
                handleState(sc);
            }
        } else if (userType === "3" && stateCodeStr) { // District login
            const sc = Number(stateCodeStr);
            if (!hasSavedSearch) setStateValue([sc]);
            setIsStateFrozen(true);
            setIsStateOrDistrictUser(true);
            if (hasSavedSearch) {
                restoreDependentFilters(saved);
            } else {
                handleState(sc);
            }

            if (districtCodeStr) {
                // Check if user has multiple districts
                const hasMultipleDistricts = String(districtCodeStr).includes(',');
                
                if (hasMultipleDistricts) {
                    // Multiple districts: DON'T freeze and DON'T auto-select - let user choose
                    setIsDistrictFrozen(false);
                } else {
                    // Single district: auto-select and freeze the dropdown
                    if (!hasSavedSearch) setDesiredDistrictCode(districtCodeStr);
                    setIsDistrictFrozen(true);
                }
            }
        } else if (hasSavedSearch) {
            restoreDependentFilters(saved);
        }
    }, []);

    // Once districts are loaded and we have a desired district code, set it
    useEffect(() => {
        if (desiredDistrictCode && optionDistrict && optionDistrict.length > 0) {
            // Try to match by district code first
            let match = optionDistrict.find(o => Number(o.value) === Number(desiredDistrictCode));
            
            // If no match by code, try matching by district name (case-insensitive)
            if (!match && isNaN(Number(desiredDistrictCode))) {
                match = optionDistrict.find(o => 
                    o.label && o.label.toLowerCase() === String(desiredDistrictCode).toLowerCase()
                );
            }
            
            if (match) {
                handleChangeDistrict(match);
                setDesiredDistrictCode(null);
                // Don't fetch here - let the next useEffect handle it after state updates
            }
        }
    }, [optionDistrict, desiredDistrictCode]);

    // For district users: once district is frozen and selectedDataSetDistrict is set, fetch data
    useEffect(() => {
        if (skipAutoFetchRef.current) return;
        if (isDistrictFrozen && selectedDataSetDistrict && selectedDataSetDistrict !== '') {
            setHasSearched(true);
            triggerFetch();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDistrictFrozen, selectedDataSetDistrict]);

    // For state users: once state is frozen and set, fetch data
    useEffect(() => {
        if (skipAutoFetchRef.current) return;
        if (isStateFrozen && stateValue && stateValue.length > 0 && !desiredDistrictCode && !isDistrictFrozen) {
            if (!hasCalledStateUserApi.current) {
                hasCalledStateUserApi.current = true;
                setHasSearched(true);
                triggerFetch();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isStateFrozen, stateValue, isDistrictFrozen, desiredDistrictCode]);

    // Central Admin users must use the Submit button — no auto-fetch on user type selection.

    function getStates() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch(
            `${baseUrl}/api/states`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent || [];
                let myArray = [];
                localFormDataState.map((item) => {
                    myArray.push({
                        value: item.stateCode,
                        label: item.stateName,
                    });
                });
                setOptionState(myArray);
            })
            .catch((error) => {
                console.error("Error fetching states:", error);
            });
    }

    function handleState(stateCodeParam = null) {
        const currentStateValue = stateCodeParam ? [stateCodeParam] : stateValue;
        setOptionDistrict([]);
        setDistrictValue('');
        setOptionSubDistrict([]);
        setsubDistrictValue('');
        setOptionVillage([]);
        setvillageValue('');

        if (currentStateValue && currentStateValue.length > 0) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = "";
            currentStateValue.map((item) => { stateValueData = stateValueData + item + ","; });
            stateValueData = stateValueData.slice(0, -1);

            var raw = JSON.stringify({ stateCode: stateValueData.toString() });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${baseUrl}/api/district`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataDistrict = JSON.parse(result).dataContent || [];
                    let myArrayDistrict = [];
                    
                    // Filter districts for district users to only show assigned districts
                    const userType = sessionStorage.getItem("userRoleCodeModel");
                    const districtCodeStr = sessionStorage.getItem("districtCodeModel");
                    
                    if (userType === "3" && districtCodeStr) {
                        // District user: filter to only assigned districts
                        const assignedDistrictCodes = String(districtCodeStr).split(',').map(code => code.trim());
                        
                        localFormDataDistrict = localFormDataDistrict.filter(item => 
                            assignedDistrictCodes.includes(String(item.districtCode))
                        );
                    }
                    
                    localFormDataDistrict.map((item) => {
                        myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                    })
                    setOptionDistrict(myArrayDistrict);
                })
                .catch((error) => console.log("error", error));
        }
    }

    let handleChangeDistrict = (selectedOption) => {
        setOptionSubDistrict([]);
        setsubDistrictValue('');
        setOptionVillage([]);
        setvillageValue('');

        if (selectedOption) {
            setDistrictValue(selectedOption.value);
            setselectedDataSetDistrict(`${selectedOption.stateid}|${selectedOption.value}`);

            let stateValueData = stateValue[0];
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var raw = JSON.stringify({
                stateCode: stateValueData?.toString() || "0",
                districtCode: selectedOption.value?.toString() || "0"
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${baseUrl}/api/subdistrict`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataSubDistrict = JSON.parse(result).dataContent || [];
                    let myArraySubDistrict = [];
                    localFormDataSubDistrict.map((item) => {
                        myArraySubDistrict.push({ label: item.subDistrictName, value: item.subDistrictCode, districtCode: item.districtCode })
                    });
                    setOptionSubDistrict(myArraySubDistrict);
                })
                .catch((error) => console.log("error", error));
        } else {
            setDistrictValue('');
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
        }
    };

    let handleChangeSubDistrict = (selectedOption) => {
        setOptionVillage([]);
        setvillageValue('');
        if (selectedOption) {
            setsubDistrictValue(selectedOption.value);
            setselectedDataSetSubDistrict(`${selectedOption.districtCode}|${selectedOption.value}`);

            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            let stateValueData = stateValue[0] || 0;
            let districtValueData = districtValue || 0;
            var raw = JSON.stringify({
                stateCode: stateValueData.toString(),
                districtCode: districtValueData.toString(),
                subDistrictCode: selectedOption.value.toString()
            });
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${baseUrl}/api/village`,
                requestOptions
            )
                .then((response) => response.text())
                .then((result) => {
                    let localFormDataVillage = JSON.parse(result).dataContent || [];
                    let myArrayVillage = [];
                    localFormDataVillage.map((item) => {
                        myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                    })
                    setOptionVillage(myArrayVillage)
                })
                .catch((error) => console.log("error", error));
        } else {
            setsubDistrictValue('');
            setselectedDataSetSubDistrict('');
        }
    };

    let handleChangeVillage = (selectedOption) => {
        if (selectedOption) {
            setvillageValue(selectedOption.value);
            setselectedDataSetVillage(`${selectedOption.subDistrictCode}|${selectedOption.value}`);
        } else {
            setvillageValue('');
            setselectedDataSetVillage('');
        }
    };

    let handleChangeStateSelect = (selectedOption) => {
        if (isStateFrozen) {
            return; // Prevent changes when frozen
        }
        setStateValue(selectedOption ? [selectedOption.value] : []);
        setValidationMsg('');
        if (!selectedOption) {
            setOptionDistrict([]);
            setDistrictValue('');
            setOptionSubDistrict([]);
            setsubDistrictValue('');
            setOptionVillage([]);
            setvillageValue('');
            setselectedDataSetDistrict('');
            setselectedDataSetSubDistrict('');
            setselectedDataSetVillage('');
            setSearchRequest(null);
        } else {
            // Clear district, sub-district, and village when state changes
            setOptionDistrict([]);
            setDistrictValue('');
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
            setsubDistrictValue('');
            setselectedDataSetSubDistrict('');
            setOptionVillage([]);
            setvillageValue('');
            setselectedDataSetVillage('');
            // Increment selectKey to force Select components to re-render
            setSelectKey(prev => prev + 1);
            // load districts for the new state
            handleState(selectedOption.value);
        }
    };

    // Builds the API payload from current filter state
    const buildCurrentParams = () => {
        const stateCodeData = (stateValue && stateValue.length > 0) ? Number(stateValue[0]) : 0;
        const districtCodeData    = selectedDataSetDistrict    ? Number(selectedDataSetDistrict.split('|')[1]    || 0) : 0;
        const subDistrictCodeData = selectedDataSetSubDistrict ? Number(selectedDataSetSubDistrict.split('|')[1] || 0) : 0;
        const villageCodeData     = selectedDataSetVillage     ? Number(selectedDataSetVillage.split('|')[1]     || 0) : 0;
        const effectiveUserType = selectedUserType ?? sessionStorage.getItem("userTypeCodeModel");

        return {
            finYear:         (!selectedFinYear || selectedFinYear === 'All') ? 0 : Number(selectedFinYear),
            stateCode:       stateCodeData,
            districtCode:    districtCodeData,
            subdistrictCode: subDistrictCodeData,
            villageCode:     villageCodeData,
            schemeCode:      Number(effectiveUserType ?? 0),
        };
    };

    // Single state update → exactly one API call per trigger
    const triggerFetch = () => {
        const req = { params: buildCurrentParams(), requestId: Date.now() };
        setSearchRequest(req);
        persistSearchState({ searchRequest: req, hasSearched: true });
    };

    function ValidateAndSearch() {
        const effectiveUserType = selectedUserType ?? sessionStorage.getItem("userTypeCodeModel");
        const hasUserType = effectiveUserType && effectiveUserType !== null && effectiveUserType !== '';
        const hasFinYear = selectedFinYear && selectedFinYear !== 'All';
        const hasState = stateValue && stateValue.length > 0;
        const hasDistrict = districtValue && districtValue !== '';
        const hasSubDistrict = subdistrictValue && subdistrictValue !== '';
        const hasVillage = villageValue && villageValue !== '';
        
        const hasAnyFilter = hasUserType || hasFinYear || hasState || hasDistrict || hasSubDistrict || hasVillage;
        
        if (!hasAnyFilter) {
            setValidationMsg('Please select User Type before submitting your search.');
            setHasSearched(false);
            return;
        }

        if (!hasUserType || Number(effectiveUserType) === 0) {
            setValidationMsg('Please select User Type before submitting your search.');
            setHasSearched(false);
            return;
        }

        const req = { params: buildCurrentParams(), requestId: Date.now() };
        setValidationMsg('');
        setHasSearched(true);
        setIsManualSearch(true);
        setAppliedUserType(effectiveUserType);
        setCurrentPage(1);
        setSearchRequest(req);
        persistSearchState({
            searchRequest: req,
            hasSearched: true,
            isManualSearch: true,
            appliedUserType: effectiveUserType,
            currentPage: 1,
        });
    }

 // Close implement modal
  const handleCloseImplementsModal = () => {
    setShowImplementsModal(false);
    setSelectedImplements(null);
  };

    function ClearSearch() {
        setFinYear('');
        setSelectedFinYear('All');
        if (!isUserTypeFrozen) {
            setSelectedUserType(null);
            setAppliedUserType(null);
        }
        if (!isStateFrozen) {
            setStateValue([]);
        }
        // Clear all district, sub-district, and village fields
        if (!isDistrictFrozen) {
            setDistrictValue('');
            setselectedDataSetDistrict('');
        }
        setsubDistrictValue('');
        setselectedDataSetSubDistrict('');
        setvillageValue('');
        setselectedDataSetVillage('');
        // Clear all options
        setOptionDistrict([]);
        setOptionSubDistrict([]);
        setOptionVillage([]);
        setHasSearched(false);
        setIsManualSearch(false);
        setValidationMsg('');
        setSearchRequest(null);
        clearPersistedSearchState();
        // Increment selectKey to force Select components to re-render
        setSelectKey(prev => prev + 1);
    }

    // ── Table: memoised helpers ───────────────────────────────────────────────

    const columns = useMemo(() => {
        const baseColumns = [
            { key: 'finYear',            label: 'Fin Year' },
            { key: 'farmerName',            label: 'Farmer Name' },
            { key: 'farmerTypeName',           label: 'Farmer Type' },
           // { key: 'contactPersonName',  label: 'Contact Person Name' },
            { key: 'stateName',          label: 'State' },
            { key: 'districtName',       label: 'District' },
            { key: 'subdistrictBlockName',    label: 'Sub District' },
            { key: 'villageName',        label: 'Village' },
            { key: 'schemeName',       label: 'Scheme' },
          //  { key: 'noOfImplements',     label: 'No. of Implement' },
            { key: 'polygonShape',       label: 'Detail' },
        ];
        const crmColumns = [
         //   { key: 'additionalRequirement', label: 'Additional Requirement' },
         //   { key: 'paddyArea_Ha',          label: 'Peddy Area (Ha)' },
          //  { key: 'nearbyPlantAddress',    label: 'Plant Address' },
        ];
        return appliedUserType === '2' ? [...baseColumns, ...crmColumns] : baseColumns;
    }, [appliedUserType]);

    const getFinYearLabel = useCallback((value) => {
        if (value === null || value === undefined || value === '') return '';

        const valueStr = String(value).trim();
        const yearFromApi = (finYears || []).find(item => {
            const idValue = item?.fyId ?? item;
            return String(idValue) === valueStr;
        });

        if (yearFromApi) {
            return String(yearFromApi.financialYear ?? yearFromApi);
        }

        return valueStr;
    }, [finYears]);

    const getValue = useCallback((row, key) => {
        if (key === 'subdistrictName') {
            return row.subdistrictName ?? row.subDistrictName ?? '';
        }
        if (key === 'finYear') {
            const rawFinYear = row.financialYear ?? row.finYear ?? row.fyId ?? row.financialYearId ?? '';
            if (rawFinYear && String(rawFinYear).trim() !== '') {
                return getFinYearLabel(rawFinYear);
            }
            return '';
        }
        return row[key] ?? '';
    }, [getFinYearLabel]);

    const handleSort = useCallback((key) => {
        setSortKey(prev => {
            if (prev === key) {
                setSortDir(d => (d === 'asc' ? 'desc' : 'asc'));
                return prev;
            }
            setSortDir('asc');
            return key;
        });
        setCurrentPage(1);
    }, []);

    const sortedRows = useMemo(() => {
        if (!sortKey || !rows || rows.length === 0) return rows;
        const data = [...rows];
        data.sort((a, b) => {
            const av = String(getValue(a, sortKey)).toLowerCase();
            const bv = String(getValue(b, sortKey)).toLowerCase();
            if (av < bv) return sortDir === 'asc' ? -1 : 1;
            if (av > bv) return sortDir === 'asc' ? 1 : -1;
            return 0;
        });
        return data;
    }, [rows, sortKey, sortDir, getValue]);

    const totalItems  = sortedRows.length;
    const totalPages  = useMemo(() => Math.max(1, Math.ceil(totalItems / pageSize)), [totalItems, pageSize]);
    const safePage    = useMemo(() => Math.min(currentPage, totalPages), [currentPage, totalPages]);
    const pageRows    = useMemo(() => {
        const start = (safePage - 1) * pageSize;
        return sortedRows.slice(start, start + pageSize);
    }, [sortedRows, safePage, pageSize]);

    const goToPage = useCallback((p) => {
        setCurrentPage(prev => {
            const np = Math.min(Math.max(1, p), Math.max(1, Math.ceil(rows.length / pageSize)));
            return np;
        });
    }, [rows.length, pageSize]);

    const exportToCsv = useCallback(() => {
        const exportColumns = columns.filter(c => c.key !== 'polygonShape');
        const header = exportColumns.map(c => c.label).join(',');
        const allRows = rows.map(r =>
            exportColumns.map(c => {
                const val = String(getValue(r, c.key)).replace(/"/g, '""');
                return `"${val}"`;
            }).join(',')
        );
        const csv = [header, ...allRows].join('\n');
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url  = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'survey_detail.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }, [columns, rows, getValue]);

    // ── Handlers for modals ───────────────────────────────────────────────────
    const parseImagePaths = (imagePath) => {
        if (!imagePath) return [];
        return String(imagePath).split(',').map(path => path.trim()).filter(path => path);
    };

    const BENEFICIARY_IMAGE_KEYS = ['imagepath', 'imagename', 'image_path', 'image_name'];
    const BENEFICIARY_HIDDEN_KEYS = ['imagelat', 'imagelong', 'surveyorlat', 'surveyorlong','casteCategory','isActive','componentID'];

    const isBeneficiaryImageField = (key) => BENEFICIARY_IMAGE_KEYS.includes(String(key).toLowerCase());
    const isBeneficiaryHiddenField = (key) => BENEFICIARY_HIDDEN_KEYS.includes(String(key).toLowerCase());

    const getBeneficiaryImagePaths = (data) => {
        if (!data || typeof data !== 'object') return [];
        const allPaths = [];

        // Check primary image field first
        const primaryImageFields = ['imagepath', 'image_path'];
        let foundPrimaryImage = false;

        for (const primaryField of primaryImageFields) {
            const fieldKey = Object.keys(data).find(k => String(k).toLowerCase() === primaryField);
            if (fieldKey && data[fieldKey]) {
                allPaths.push(...parseImagePaths(data[fieldKey]));
                foundPrimaryImage = true;
                break; // Only use the first found primary field
            }
        }

        // Only check secondary fields if no primary image field was found
        if (!foundPrimaryImage) {
            Object.entries(data).forEach(([key, value]) => {
                const lowerKey = String(key).toLowerCase();
                if ((lowerKey === 'imagename' || lowerKey === 'image_name') && value) {
                    allPaths.push(...parseImagePaths(value));
                }
            });
        }

        // Remove duplicates and return
        return [...new Set(allPaths.map(path => String(path).trim()).filter(Boolean))];
    };

    const toAbsoluteImageUrl = (rawPath) => {
        if (!rawPath) return '';
        const normalizedPath = String(rawPath).trim().replace(/\\/g, '/');

        // Already a full URL or data URI
        if (/^(https?:)?\/\//i.test(normalizedPath) || normalizedPath.startsWith('data:')) {
            return normalizedPath;
        }

        // Construct proper image URL from base URL
        // Backend images are typically stored in CommonModel/Staging or similar directories
        const cleanBaseUrl = String(baseUrl || '').replace(/\/$/, '');
        
        // If path already contains directory structure, use as-is
        if (normalizedPath.includes('CommonModel') || normalizedPath.includes('uploads')) {
            const pathWithSlash = normalizedPath.startsWith('/') ? normalizedPath : `/${normalizedPath}`;
            return cleanBaseUrl ? `${cleanBaseUrl}${pathWithSlash}` : normalizedPath;
        }
        
        // For simple filenames, try common image directories
        // First try: /upload/ directory (common pattern)
        const imageUrl = `${cleanBaseUrl}/upload/${normalizedPath}`;
        return imageUrl;
    };

    const handleImplementsClick = async (row) => {
        // Prevent duplicate API calls
        if (implementsApiCallInProgress.current) {
            console.log('Implements API call already in progress, ignoring duplicate click');
            return;
        }

        // Get CHC ID from row - try multiple possible field names
        const chcId = row.id || row.chcId || row.chcid || row.chcID;
        
        if (!chcId) {
            alert('CHC ID not found in the record');
            return;
        }

        // Mark API call as in progress
        implementsApiCallInProgress.current = true;
        
        setLoadingImplements(true);
        setShowImplementsModal(true);
        setSelectedImplements(null);
        setImplementsModalError(null);

        try {
            console.log('Fetching implements for CHC ID:', chcId);
            const userTypeCode = parseInt(sessionStorage.getItem("userTypeCodeModel") || sessionStorage.getItem("userRoleCodeModel") || "2");
            
            const { data } = await axios.post(
                `${baseUrl}/api/ExpensiveMachinery/GetExpBenDataByBenID`,
                {
                    beneficiaryId: parseInt(chcId),
                },
                {
                    headers: {
                        'accept': '*/*',
                        'Content-Type': 'application/json'
                    }
                }
            );

            console.log('Implement Details API Response:', data);

            if (data && data.success && data.dataContent) {
                // Flatten the nested structure: each category can have multiple implements
                const flattenedImplements = [];
                let totalImplements = 0;
                
                data.dataContent.forEach((category) => {
                    if (category.implements && Array.isArray(category.implements)) {
                        category.implements.forEach((implement) => {
                            flattenedImplements.push({
                                categoryName: category.categoryName || 'N/A',
                                implementName: implement.implementName || 'N/A',
                                implementID: implement.implementID,
                                implementCount: implement.implementCount,
                                isWorking: implement.isWorking,
                                areaCovered: implement.areaCovered
                            });
                            totalImplements++;                                   
                        });
                    }
                });
                
                // Transform the response to match the expected format
                const implementData = {
                    chcName: row.chcName || 'N/A',
                    noOfImplements: totalImplements,
                    implementDetailsJSON: JSON.stringify(flattenedImplements)
                };
                setSelectedImplements(implementData);
                setImplementsModalError(null);
            } else if (data && data.success === false) {
                setImplementsModalError(data.message || 'No implements data available.');
                setSelectedImplements(null);
            } else {
                setImplementsModalError('No implements data available.');
                setSelectedImplements(null);
            }
        } catch (error) {
            console.error('Error fetching implement details:', error);
            console.error('Error details:', {
                message: error.message,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                url: error.config?.url
            });
            
            const errorMessage = error.response?.data?.message 
                || error.response?.statusText 
                || error.message 
                || 'Failed to load implement details. Please try again.';
            
            setImplementsModalError(errorMessage);
            setSelectedImplements(null);
        } finally {
            setLoadingImplements(false);
            // Allow new API calls after this one completes
            implementsApiCallInProgress.current = false;
        }
    };
 // Fetch expensive machinery implements for a beneficiary and show modal
  const handleViewExpImplements = async (beneficiaryId) => {
    setLoadingImplements(true);
    setShowImplementsModal(true);
    setImplementsModalError(null);
    setSelectedImplements(null);

    try {
      console.log('Fetching expensive machinery implements for beneficiary ID:', beneficiaryId);
      const { data } = await axios.post(
        `${baseUrl}/api/ExpensiveMachinery/GetExpImplemnetData`,
        { beneficiaryId: parseInt(beneficiaryId) },
        { headers: { accept: '*/*', 'Content-Type': 'application/json' } }
      );

      console.log('ExpImplements response:', data);
      if (data && data.success && Array.isArray(data.dataContent) && data.dataContent.length > 0) {
        setExpImplementsByBeneficiary(prev => ({ ...prev, [beneficiaryId]: data.dataContent }));
        setSelectedImplements({
          beneficiaryId,
          displayName: data.implementName,
          implementDetails: data.dataContent,
          noOfImplements: data.dataContent.length
        });
        setImplementsModalError(null);
      } else if (data && data.success === false) {
        setImplementsModalError(data.message || 'No implements data available for this beneficiary.');
        setSelectedImplements(null);
      } else {
        setImplementsModalError('No implements data available for this beneficiary.');
        setSelectedImplements(null);
      }
    } catch (error) {
      console.error('Error fetching expensive machinery implements:', error);
      console.error('Error details:', {
        message: error.message,
        status: error.response?.status,
        statusText: error.response?.statusText,
        data: error.response?.data,
        url: error.config?.url
      });
      
      const errorMessage = error.response?.data?.message 
        || error.response?.statusText 
        || error.message 
        || 'Failed to load implement details. Please try again.';
      
      setImplementsModalError(errorMessage);
      setSelectedImplements(null);
    } finally {
      setLoadingImplements(false);
    }
  };

    const closeImplementsModal = () => {
        setShowImplementsModal(false);
        setSelectedImplements(null);
        setLoadingImplements(false);
        setImplementsModalError(null);
    };

   const handlePolygonClick = (rowData) => {
        setSelectedPolygon(rowData);
        setShowPolygonModal(true);
    };

    const handleBeneficiaryClick = async (row) => {
        // Prevent duplicate API calls
        if (beneficiaryApiCallInProgress.current) {
            console.log('API call already in progress, ignoring duplicate click');
            return;
        }

        const beneficiaryId =
            row?.beneficiaryId ??
            row?.BeneficiaryId ??
            row?.beneficiary_id ??
            row?.beneficiaryID ??
            row?.beneficiaryid ??
            row?.id ??
            row?.Id;

        const normalizedBeneficiaryId =
            beneficiaryId !== undefined && beneficiaryId !== null
                ? String(beneficiaryId).trim()
                : '';

        if (!normalizedBeneficiaryId) {
            alert('Beneficiary ID not found in the record');
            return;
        }

        // Mark API call as in progress
        beneficiaryApiCallInProgress.current = true;
        
        setLoadingBen(true);
        setSelectedBenData(null);
        setBenModalError(null);

        try {
            console.log('Fetching beneficiary details for ID:', normalizedBeneficiaryId);
            console.log('API Endpoint:', `${baseUrl}/api/ExpensiveMachinery/GetExpBenDataByBenID`);
            
            const { data } = await axios.post(
                `${baseUrl}/api/ExpensiveMachinery/GetExpBenDataByBenID`,
                { beneficiaryId: parseInt(normalizedBeneficiaryId, 10) },
                { headers: { accept: '*/*', 'Content-Type': 'application/json' } }
            );

            console.log('Beneficiary Detail API Response:', data);
            
            if (data && data.dataContent) {
                const content = Array.isArray(data.dataContent) ? data.dataContent[0] : data.dataContent;
                const polygonShapeFromRow = row?.polygonShape || row?.strPolygonShape || null;
                const mergedFarmerData = {
                    ...(row || {}),
                    ...(content || {}),
                    // Ensure polygon fields survive when API payload doesn't include them.
                    polygonShape: (content && (content.polygonShape || content.strPolygonShape)) || polygonShapeFromRow,
                    strPolygonShape: (content && (content.strPolygonShape || content.polygonShape)) || polygonShapeFromRow,
                };

                persistSearchState();
                navigate('/MNT/SurveyorDetailView', {
                    state: {
                        farmerData: mergedFarmerData,
                    },
                });
            } else if (data && data.success === false) {
                const msg = data.message || 'No data available for this beneficiary.';
                setBenModalError(msg);
                alert(msg);
            } else {
                const msg = 'No beneficiary data available.';
                setBenModalError(msg);
                alert(msg);
            }
        } catch (error) {
            console.error('Error fetching beneficiary details:', error);
            console.error('Error details:', {
                message: error.message,
                status: error.response?.status,
                statusText: error.response?.statusText,
                data: error.response?.data,
                url: error.config?.url
            });
            
            const errorMessage = error.response?.data?.message 
                || error.response?.statusText 
                || error.message 
                || 'Failed to load beneficiary details. Please try again.';
            
            setBenModalError(errorMessage);
            alert(errorMessage);
        } finally {
            setLoadingBen(false);
            // Allow new API calls after this one completes
            beneficiaryApiCallInProgress.current = false;
        }
    };

    const closeBenModal = () => {
        setShowBenModal(false);
        setSelectedBenData(null);
        setBenModalError(null);
        setSelectedPolygon(null);
        setPolygonMap(null);
    };


    const closePolygonModal = () => {
        setShowPolygonModal(false);
        setSelectedPolygon(null);
        setPolygonMap(null);
    };

    const beneficiaryImagePaths = useMemo(
        () => getBeneficiaryImagePaths(selectedBenData),
        [selectedBenData]
    );

    const renderRows = () => {
        if (!rows || rows.length === 0) return null;

        return (
            <div className="table-responsive">
                <div className="d-flex align-items-center justify-content-between mb-2">
                    <div className="d-flex align-items-center gap-2">
                        <label className="me-2">Page size</label>
                        <select
                            className="form-select form-select-sm"
                            style={{ width: 90 }}
                            value={pageSize}
                            onChange={(e) => { setPageSize(Number(e.target.value)); setCurrentPage(1); }}
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <span className="ms-3">Total: {totalItems}</span>
                    </div>
                    <button type="button" className="btn btn-outline-primary btn-sm" onClick={exportToCsv}>Export CSV</button>
                </div>
                <table className="table table-bordered table-striped table-sm">
                    <thead>
                        <tr>
                            {columns.map((c) => (
                                <th
                                    key={c.key}
                                    role="button"
                                    onClick={() => handleSort(c.key)}
                                    title="Click to sort"
                                >
                                    {c.label}
                                    {sortKey === c.key ? (
                                        <span className="ms-1">{sortDir === 'asc' ? '▲' : '▼'}</span>
                                    ) : null}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {pageRows.map((r, idx) => (
                            <tr key={r.id ?? idx}>
                                {columns.map((c) => (
                                    <td key={c.key}>
                                        {c.key === 'noOfImplements' ? (
                                            <a
                                                href="#!"
                                                onClick={(e) => { e.preventDefault(); handleImplementsClick(r); }}
                                                className="text-primary"
                                                style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                            >
                                                {String(getValue(r, c.key))}
                                            </a>
                                        ) : c.key === 'polygonShape' ? (
                                            <button
                                                className="btn btn-sm btn-link p-0"
                                                // onClick={() => handleViewExpImplements(r.beneficiaryId)}
                                                  onClick={() => handleBeneficiaryClick(r)}
                                              //  onClick={() => handlePolygonClick(r)}
                                                title="View Detail"
                                            >
                                                <i className="bi bi-eye-fill" style={{ fontSize: '1.2rem', color: '#28a745' }}></i>
                                            </button>
                                        ) : (
                                            String(getValue(r, c.key))
                                        )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        Page {safePage} of {totalPages}
                    </div>
                    <div className="btn-group btn-group-sm" role="group">
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(1)} disabled={safePage === 1}>{'<<'}</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(safePage - 1)} disabled={safePage === 1}>{'<'}</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(safePage + 1)} disabled={safePage === totalPages}>{'>'}</button>
                        <button type="button" className="btn btn-outline-secondary" onClick={() => goToPage(totalPages)} disabled={safePage === totalPages}>{'>>'}</button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarNew />

            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                    <nav>
                        <h1>Survey List</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Survey</li>
                            <li className="breadcrumb-item active">Individual Survey Detail</li>
                            <li className="breadcrumb-item">
                                {(() => {
                                    const userTypeCode = Number(sessionStorage.getItem("userTypeCodeModel"));
                                    switch(userTypeCode) {
                                        case 1: return "FMTTI";
                                        case 2: return "CRM";
                                        case 3: return "SMAM";
                                        
                                    }
                                })()}
                            </li>
                        </ol>
                    </nav>
                </div>

                <section className="section">
                    <div className="row surveydetailsBg">
                        <div className="col-md-3">
                        <label htmlFor="userTypeDropdown" className="form-label">User Type</label>
                        <Select
                            id="userTypeDropdown"
                            options={availableUserTypeOptions}
                            value={availableUserTypeOptions.find(opt => opt.value === selectedUserType) || null}
                            onChange={opt => {
                                const newType = opt ? opt.value : null;
                                setSelectedUserType(newType);
                                // CRM select hone par agar selected state allowed list mein nahi hai to clear karo
                                if (newType === '2' && stateValue && stateValue.length > 0) {
                                    const selectedStateLabel = optionState.find(s => s.value === stateValue[0])?.label;
                                    if (!CRM_ALLOWED_STATES.includes(selectedStateLabel)) {
                                        setStateValue([]);
                                        setOptionDistrict([]);
                                        setDistrictValue('');
                                        setOptionSubDistrict([]);
                                        setsubDistrictValue('');
                                        setOptionVillage([]);
                                        setvillageValue('');
                                    }
                                }
                            }}
                            isClearable={!isUserTypeFrozen}
                            isSearchable={false}
                            placeholder="Select Component Type"
                            classNamePrefix="select"
                            isDisabled={isUserTypeFrozen}
                        />
                        </div>
                        <div className="col-md-3">
                            <label htmlFor="finYear" className="form-label">Fin Year</label>
                           <Select
    options={(finYears || []).map(item => ({
        label: item.financialYear,
        value: item.fyId
    }))}
    value={
        selectedFinYear
            ? (finYears || [])
                .map(item => ({
                    label: item.financialYear,
                    value: item.fyId
                }))
                .find(opt => opt.value === selectedFinYear)
            : null
    }
    onChange={(opt) => setSelectedFinYear(opt ? opt.value : null)}
    isClearable
    isSearchable
    placeholder="Select Fin Year"
    menuPortalTarget={document.body}
    menuPosition="fixed"
    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
/>
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="State" className="form-label">State</label>
                            <Select
                                options={filteredStateOptions}
                                value={stateValue && stateValue.length > 0 ? filteredStateOptions.find(option => option.value === stateValue[0]) : null}
                                onChange={handleChangeStateSelect}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select State"
                                classNamePrefix="select"
                                isDisabled={isStateFrozen}
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="District" className="form-label">District</label>
                            <Select
                                key={`district-${selectKey}`}
                                options={optionDistrict}
                                value={optionDistrict.find(option => option.value === districtValue)}
                                onChange={handleChangeDistrict}
                                isClearable={true}
                                isSearchable={true}
                                placeholder="Select District"
                                classNamePrefix="select"
                                isDisabled={isDistrictFrozen}
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="SubDistrict" className="form-label">Sub District</label>
                            <Select
                                key={`subdistrict-${selectKey}`}
                                options={optionSubDistrict}
                                value={optionSubDistrict.find(option => option.value === subdistrictValue)}
                                onChange={handleChangeSubDistrict}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Sub District"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        <div className="col-md-3">
                            <label htmlFor="Village" className="form-label">Village</label>
                            <Select
                                key={`village-${selectKey}`}
                                options={optionVillage}
                                value={optionVillage.find(option => option.value === villageValue)}
                                onChange={handleChangeVillage}
                                isClearable={true}
                                isSearchable={true}
                                isMulti={false}
                                hideSelectedOptions={false}
                                placeholder="Select Village"
                                classNamePrefix="select"
                                components={{
                                    Option: ({ children, ...props }) => (
                                        <components.Option {...props}>{children}</components.Option>
                                    )
                                }}
                            />
                        </div>

                        <div className="col-md-12 d-flex justify-content-md-center mt-3">
                            <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={ValidateAndSearch} disabled={loading}>{loading ? 'Searching...' : 'Submit'}</button>
                            <button type="button" className="btn btn-success me-md-2" onClick={ClearSearch}>Clear</button>
                        </div>
                    </div>

                    {validationMsg && (
                        <div className="alert alert-danger mt-3" role="alert">{validationMsg}</div>
                    )}
                    {hasSearched && errorMessage && (
                        <div className="alert alert-danger mt-3" role="alert">{errorMessage}</div>
                    )}

                    {hasSearched && (
                        <div className="row mt-3">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        {rows.length > 0 ? (
                                            renderRows()
                                        ) : isManualSearch ? (
                                            <div className="alert alert-info" role="alert">
                                                No survey records found matching your selected filters.
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </section>

                {loading === false ? "" : <div className="overlay"><div className="overlay__inner"><div className="overlay__content"><span className="spinner"></span></div></div></div>}
                
                {/* Polygon Modal */}
                {showPolygonModal && selectedPolygon && (
                    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={closePolygonModal}>
                                           <div className="modal-dialog modal-dialog-centered modal-xl" onClick={(e) => e.stopPropagation()}>
                                               <div className="modal-content">
                                                   <div className="modal-header">
                                                       <h5 className="modal-title">Details</h5>
                                                       <button type="button" className="btn-close" onClick={closePolygonModal}>x</button>
                                                   </div>
                                                   <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                                                       {isLoaded ? (
                                                           <GoogleMap
                                                               mapContainerStyle={{ width: "100%", height: "50vh" }}
                                                               center={{ lat: 28.641832439372656, lng: 77.22480777651072 }}
                                                               zoom={18}
                                                               onLoad={(map) => {
                                                                   setPolygonMap(map);
                                                                   try {
                                                                       const polygonData = JSON.parse(selectedPolygon.polygonShape);
                                                                       const polygon = new window.google.maps.Polygon({
                                                                           paths: polygonData,
                                                                           strokeColor: "#FF0000",
                                                                           strokeOpacity: 1,
                                                                           strokeWeight: 2,
                                                                           fillColor: "#FF0000",
                                                                           fillOpacity: 0.1,
                                                                       });
                                                                       
                                                                       polygon.setMap(map);
                                                                       
                                                                       // Calculate and set bounds
                                                                       const bounds = new window.google.maps.LatLngBounds();
                                                                       polygonData.forEach(point => {
                                                                           bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
                                                                       });
                                                                       map.fitBounds(bounds);
                                                                       
                                                                       // Add marker at center
                                                                       const center = bounds.getCenter();
                                                                       const marker = new window.google.maps.Marker({
                                                                           position: center,
                                                                           map: map,
                                                                           title: "Click to zoom",
                                                                       });
                                                                       
                                                                       marker.addListener("click", () => {
                                                                           map.panTo(marker.getPosition());
                                                                           map.setZoom(18);
                                                                       });
                                                                   } catch (error) {
                                                                       console.error("Error rendering polygon:", error);
                                                                   }
                                                               }}
                                                               onUnmount={() => setPolygonMap(null)}
                                                               mapTypeId="satellite"
                                                           />
                                                       ) : (
                                                           <div style={{ width: "100%", height: "50vh", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
                                                               <div className="text-center">
                                                                   <div className="spinner-border text-primary" role="status">
                                                                       <span className="visually-hidden">Loading...</span>
                                                                   </div>
                                                                   <p className="mt-2">Loading map...</p>
                                                               </div>
                                                           </div>
                                                       )}
                                                       
                                                       <div className="mt-4">
                                                           <h6 className="mb-3"><strong>Survey Details</strong></h6>
                                                           <div className="row surveydetailsbg">
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>CHC Name</h6>
                                                                   <p>{selectedPolygon.chcName || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Contact Person</h6>
                                                                   <p>{selectedPolygon.contactPersonName || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Mobile Number</h6>
                                                                   <p>{selectedPolygon.mobileNo || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Financial Year</h6>
                                                                   <p>{selectedPolygon.finYear || 'N/A'}</p>
                                                               </div>
                                                           </div>
                                                           
                                                           <h6 className="mb-3 mt-3"><strong>Location Details</strong></h6>
                                                           <div className="row surveydetailsbg">
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>State</h6>
                                                                   <p>{selectedPolygon.stateName || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>District</h6>
                                                                   <p>{selectedPolygon.districtName || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Sub District</h6>
                                                                   <p>{selectedPolygon.subdistrictName || selectedPolygon.subDistrictName || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Village</h6>
                                                                   <p>{selectedPolygon.villageName || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Landmark Address</h6>
                                                                   <p>{selectedPolygon.landMarkAddress || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Area Type</h6>
                                                                   <p>{selectedPolygon.areaType === "1" ? "Rural" : selectedPolygon.areaType === "2" ? "Urban" : 'N/A'}</p>
                                                               </div>
                                                           </div>
                                                           
                                                           {/* <h6 className="mb-3 mt-3"><strong>Polygon Information</strong></h6>
                                                           <div className="row surveydetailsbg">
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Polygon Area (sq.m)</h6>
                                                                   <p>{selectedPolygon.polygonArea || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Image Latitude</h6>
                                                                   <p>{selectedPolygon.imageLat || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Image Longitude</h6>
                                                                   <p>{selectedPolygon.imageLong || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Surveyor Latitude</h6>
                                                                   <p>{selectedPolygon.surveyorLat || 'N/A'}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Surveyor Longitude</h6>
                                                                   <p>{selectedPolygon.surveyorLong || 'N/A'}</p>
                                                               </div>
                                                           </div> */}
                                                           
                                                           <h6 className="mb-3 mt-3"><strong>Additional Details</strong></h6>
                                                           <div className="row surveydetailsbg">
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Established By</h6>
                                                                   <p>{selectedPolygon.establishedByName}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Establishment Year</h6>
                                                                   <p>{selectedPolygon.year}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Establishment Month</h6>
                                                                   <p>{selectedPolygon.monthName}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Registration Number</h6>
                                                                   <p>{selectedPolygon.societyRegistrationNumber}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>GST Number</h6>
                                                                   <p>{selectedPolygon.gsT_NO}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Scheme Type</h6>
                                                                   <p>{selectedPolygon.userTypeName}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Under Scheme</h6>
                                                                   <p>{selectedPolygon.underSchemeName}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Component Name</h6>
                                                                   <p>{selectedPolygon.componentName}</p>
                                                               </div>
                                                               <div className="col-md-3 mb-3">
                                                                   <h6>Created Date</h6>
                                                                   <p>{selectedPolygon.createdOn ? selectedPolygon.createdOn.split('T')[0] : 'N/A'}</p>
                                                               </div>
                                                           </div>
                   
                                                           <h6 className="mb-3 mt-3"><strong>CHC Images</strong></h6>
                                                           <div className="row surveydetailsbg">
                                                               {parseImagePaths(selectedPolygon.imagePath).length > 0 ? (
                                                                   parseImagePaths(selectedPolygon.imagePath).map((imagePath, index) => (
                                                                       <div className="col-md-4 mb-3" key={`${imagePath}-${index}`}>
                                                                           <img
                                                                               src={imagePath}
                                                                               alt={`CHC ${index + 1}`}
                                                                               style={{ width: '100%', maxHeight: '220px', objectFit: 'cover', borderRadius: '6px' }}
                                                                               onError={(e) => {
                                                                                   e.target.onerror = null;
                                                                                   e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="260" height="180"><rect width="100%" height="100%" fill="%23f2f2f2"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="%23999" font-size="14">Image not available</text></svg>';
                                                                               }}
                                                                           />
                                                                       </div>
                                                                   ))
                                                               ) : (
                                                                   <div className="col-12">
                                                                       <p className="mb-0">No image available</p>
                                                                   </div>
                                                               )}
                                                           </div>
                                                       </div>
                                                   </div>
                                                   
                                                   <div className="modal-footer">
                                                       <button type="button" className="btn btn-secondary" onClick={closePolygonModal}>Close</button>
                                                   </div>
                                               </div>
                                           </div>
                                       </div>
                )}
                
              
            </main>

            <AdminFooterNew />

            {/* Beneficiary Detail Modal */}
            {showBenModal && (selectedBenData || benModalError) && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={closeBenModal}>
                    <div className="modal-dialog modal-dialog-centered modal-lg" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Beneficiary Details</h5>
                                <button type="button" className="btn-close" onClick={closeBenModal}>x</button>
                            </div>
                            <div className="modal-body" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                               {isLoaded && selectedPolygon?.polygonShape ? (
                                                                       <GoogleMap
                                                                           mapContainerStyle={{ width: "100%", height: "50vh" }}
                                                                           center={{ lat: 28.641832439372656, lng: 77.22480777651072 }}
                                                                           zoom={18}
                                                                           onLoad={(map) => {
                                                                               setPolygonMap(map);
                                                                               try {
                                                                                   const polygonData = JSON.parse(selectedPolygon.polygonShape);
                                                                                   if (!Array.isArray(polygonData) || polygonData.length === 0) {
                                                                                       return;
                                                                                   }
                                                                                   const polygon = new window.google.maps.Polygon({
                                                                                       paths: polygonData,
                                                                                       strokeColor: "#FF0000",
                                                                                       strokeOpacity: 1,
                                                                                       strokeWeight: 2,
                                                                                       fillColor: "#FF0000",
                                                                                       fillOpacity: 0.1,
                                                                                   });
                                                                                   
                                                                                   polygon.setMap(map);
                                                                                   
                                                                                   // Calculate and set bounds
                                                                                   const bounds = new window.google.maps.LatLngBounds();
                                                                                   polygonData.forEach(point => {
                                                                                       bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
                                                                                   });
                                                                                   map.fitBounds(bounds);
                                                                                   
                                                                                   // Add marker at center
                                                                                   const center = bounds.getCenter();
                                                                                   const marker = new window.google.maps.Marker({
                                                                                       position: center,
                                                                                       map: map,
                                                                                       title: "Click to zoom",
                                                                                   });
                                                                                   
                                                                                   marker.addListener("click", () => {
                                                                                       map.panTo(marker.getPosition());
                                                                                       map.setZoom(18);
                                                                                   });
                                                                               } catch (error) {
                                                                                   console.error("Error rendering polygon:", error);
                                                                               }
                                                                           }}
                                                                           onUnmount={() => setPolygonMap(null)}
                                                                           mapTypeId="satellite"
                                                                       />
                                                                   ) : isLoaded ? (
                                                                       <div style={{ width: "100%", height: "50vh", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
                                                                           <div className="text-center">
                                                                               <p className="mb-0">Location polygon is not available for this record.</p>
                                                                           </div>
                                                                       </div>
                                                                   ) : (
                                                                       <div style={{ width: "100%", height: "50vh", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
                                                                           <div className="text-center">
                                                                               <div className="spinner-border text-primary" role="status">
                                                                                   <span className="visually-hidden">Loading...</span>
                                                                               </div>
                                                                               <p className="mt-2">Loading map...</p>
                                                                           </div>
                                                                       </div>
                                                                   )}
                                                                   
                                {loadingBen ? (
                                    <div className="text-center py-4">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                        <p className="mt-2">Loading details...</p>
                                    </div>
                                ) : benModalError ? (
                                    <div className="alert alert-danger" role="alert">
                                        <h6 className="alert-heading">Error</h6>
                                        <p className="mb-0">{benModalError}</p>
                                    </div>
                                ) : selectedBenData && Object.keys(selectedBenData).length > 0 ? (
                                    <>
                                        <div className="row">
                                            {Object.entries(selectedBenData).map(([key, value]) => (
                                                value !== null && value !== undefined && value !== '' && !isBeneficiaryImageField(key) && !isBeneficiaryHiddenField(key) ? (
                                                    <div className="col-md-6 mb-3" key={key}>
                                                        <div className="border rounded p-2">
                                                            <small className="text-muted d-block" style={{ fontSize: '0.75rem', textTransform: 'capitalize' }}>
                                                                {key.replace(/([A-Z])/g, ' $1').trim()}
                                                            </small>
                                                            <span style={{ fontWeight: 500 }}>{String(value)}</span>
                                                        </div>
                                                    </div>
                                                ) : null
                                            ))}
                                        </div>

                                        {beneficiaryImagePaths.length > 0 ? (
                                            <div className="mt-2">
                                                <h6 className="mb-2">Images</h6>
                                                <div className="row">
                                                    {beneficiaryImagePaths.map((imagepath, index) => {
                                                        const absoluteUrl = toAbsoluteImageUrl(imagepath);
                                                        console.log(`Image ${index + 1} - Raw: ${imagepath}, Constructed URL: ${absoluteUrl}`);
                                                        return (
                                                            <div className="col-md-4 mb-3" key={`${imagepath}-${index}`}>
                                                                <img
                                                                    src={absoluteUrl}
                                                                    alt={`Beneficiary ${index + 1}`}
                                                                    style={{ width: '100%', maxHeight: '220px', objectFit: 'cover', borderRadius: '6px' }}
                                                                    onError={(e) => {
                                                                        e.target.onerror = null;
                                                                        e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="260" height="180"><rect width="100%" height="100%" fill="%23f2f2f2"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="%23999" font-size="14">Image not available</text></svg>';
                                                                    }}
                                                                />
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ) : null}
                                    </>
                                ) : (
                                    <div className="alert alert-info">No beneficiary data available.</div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeBenModal}>Close</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
              {/* Implement Details Modal */}
      {showImplementsModal && (selectedImplements || implementsModalError) && (
        <div
          className="modal fade show"
          style={{ display: 'block', backgroundColor: 'rgba(193, 183, 183, 0.5)' }}
          tabIndex="-1"
          aria-labelledby="implementModalLabel"
          aria-hidden="false"
          onClick={handleCloseImplementsModal}
        >
          <div 
            className="modal-dialog modal-lg modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-header" style={{ backgroundColor: '#c9ebc9', borderBottom: '0px solid #dee2e6' }}>
                <h5 className="modal-title" id="implementModalLabel" style={{ fontWeight: 'bold' }}>
                  Implement Details
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseImplementsModal}
                  aria-label="Close"
                >x</button>
              </div>
              <div className="modal-body" style={{ minHeight: '300px' }}>
                {loadingImplements ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-2">Loading implements details...</p>
                  </div>
                ) : implementsModalError ? (
                  <div className="alert alert-danger" role="alert">
                    <h6 className="alert-heading">Error</h6>
                    <p className="mb-0">{implementsModalError}</p>
                  </div>
                ) : selectedImplements ? (
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped">
                      <thead className="table-light123">
                        <tr>
                          <th style={{ width: '10%' }}>S.No</th>
                          <th style={{ width: '45%' }}>Category Name</th>
                          <th style={{ width: '45%' }}>Implement Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          try {
                            const implementDetails = selectedImplements.implementDetails
                              ? selectedImplements.implementDetails
                              : selectedImplements.implementDetailsJSON
                                ? JSON.parse(selectedImplements.implementDetailsJSON)
                                : [];

                            if (!Array.isArray(implementDetails) || implementDetails.length === 0) {
                              return (
                                <tr>
                                  <td colSpan="3" className="text-center">No implement details available</td>
                                </tr>
                              );
                            }

                            return implementDetails.map((item, index) => {
                              const categoryName = item.categoryName || item.CategoryName || 'N/A';
                              const implementName = item.implementName || item.ImplementName || item.ImplementSubsidyName || 'N/A';

                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{categoryName}</td>
                                  <td>{implementName}</td>
                                </tr>
                              );
                            });
                          } catch (error) {
                            console.error('Error parsing implement details:', error);
                            return (
                              <tr>
                                <td colSpan="3" className="text-center text-danger">Error loading implement details</td>
                              </tr>
                            );
                          }
                        })()}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="alert alert-info">No implement data available.</div>
                )}
              </div>
              <div className="modal-footer" style={{ backgroundColor: '#c9ebc9', borderTop: '1px solid #dee2e6' }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleCloseImplementsModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
       {/* Polygon Modal */}
                      {showPolygonModal && selectedPolygon && (
                          <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={closePolygonModal}>
                              <div className="modal-dialog modal-dialog-centered modal-xl" onClick={(e) => e.stopPropagation()}>
                                  <div className="modal-content">
                                      <div className="modal-header">
                                          <h5 className="modal-title">Details</h5>
                                          <button type="button" className="btn-close" onClick={closePolygonModal}>x</button>
                                      </div>
                                      <div className="modal-body" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                                          {isLoaded ? (
                                              <GoogleMap
                                                  mapContainerStyle={{ width: "100%", height: "50vh" }}
                                                  center={{ lat: 28.641832439372656, lng: 77.22480777651072 }}
                                                  zoom={18}
                                                  onLoad={(map) => {
                                                      setPolygonMap(map);
                                                      try {
                                                          const polygonData = JSON.parse(selectedPolygon.polygonShape);
                                                          const polygon = new window.google.maps.Polygon({
                                                              paths: polygonData,
                                                              strokeColor: "#FF0000",
                                                              strokeOpacity: 1,
                                                              strokeWeight: 2,
                                                              fillColor: "#FF0000",
                                                              fillOpacity: 0.1,
                                                          });
                                                          
                                                          polygon.setMap(map);
                                                          
                                                          // Calculate and set bounds
                                                          const bounds = new window.google.maps.LatLngBounds();
                                                          polygonData.forEach(point => {
                                                              bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
                                                          });
                                                          map.fitBounds(bounds);
                                                          
                                                          // Add marker at center
                                                          const center = bounds.getCenter();
                                                          const marker = new window.google.maps.Marker({
                                                              position: center,
                                                              map: map,
                                                              title: "Click to zoom",
                                                          });
                                                          
                                                          marker.addListener("click", () => {
                                                              map.panTo(marker.getPosition());
                                                              map.setZoom(18);
                                                          });
                                                      } catch (error) {
                                                          console.error("Error rendering polygon:", error);
                                                      }
                                                  }}
                                                  onUnmount={() => setPolygonMap(null)}
                                                  mapTypeId="satellite"
                                              />
                                          ) : (
                                              <div style={{ width: "100%", height: "50vh", display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f0f0f0' }}>
                                                  <div className="text-center">
                                                      <div className="spinner-border text-primary" role="status">
                                                          <span className="visually-hidden">Loading...</span>
                                                      </div>
                                                      <p className="mt-2">Loading map...</p>
                                                  </div>
                                              </div>
                                          )}
                                          
                                          <div className="mt-4">
                                              <h6 className="mb-3"><strong>Farmer Details</strong></h6>
                                              <div className="row surveydetailsbg">
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Farmer Name</h6>
                                                      <p>{selectedPolygon.farmerName || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Contact Person</h6>
                                                      <p>{selectedPolygon.contactPersonName || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Mobile Number</h6>
                                                      <p>{selectedPolygon.mobileNumber || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Financial Year</h6>
                                                      <p>{selectedPolygon.financialYear || 'N/A'}</p>
                                                  </div>
                                              </div>
                                              
                                              <h6 className="mb-3 mt-3"><strong>Location Details</strong></h6>
                                              <div className="row surveydetailsbg">
                                                  <div className="col-md-3 mb-3">
                                                      <h6>State</h6>
                                                      <p>{selectedPolygon.stateName || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>District</h6>
                                                      <p>{selectedPolygon.districtName || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Sub District</h6>
                                                      <p>{selectedPolygon.subdistrictName || selectedPolygon.subDistrictName || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Village</h6>
                                                      <p>{selectedPolygon.villageName || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Landmark Address</h6>
                                                      <p>{selectedPolygon.landMarkAddress || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Area Type</h6>
                                                      <p>{selectedPolygon.areaType === "1" ? "Rural" : selectedPolygon.areaType === "2" ? "Urban" : 'N/A'}</p>
                                                  </div>
                                              </div>
                                              
                                              {/* <h6 className="mb-3 mt-3"><strong>Polygon Information</strong></h6>
                                              <div className="row surveydetailsbg">
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Polygon Area (sq.m)</h6>
                                                      <p>{selectedPolygon.polygonArea || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Image Latitude</h6>
                                                      <p>{selectedPolygon.imageLat || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Image Longitude</h6>
                                                      <p>{selectedPolygon.imageLong || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Surveyor Latitude</h6>
                                                      <p>{selectedPolygon.surveyorLat || 'N/A'}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Surveyor Longitude</h6>
                                                      <p>{selectedPolygon.surveyorLong || 'N/A'}</p>
                                                  </div>
                                              </div> */}
                                              
                                              <h6 className="mb-3 mt-3"><strong>Additional Details</strong></h6>
                                              <div className="row surveydetailsbg">
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Established By</h6>
                                                      <p>{selectedPolygon.establishedByName}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Establishment Year</h6>
                                                      <p>{selectedPolygon.year}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Establishment Month</h6>
                                                      <p>{selectedPolygon.monthName}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Registration Number</h6>
                                                      <p>{selectedPolygon.societyRegistrationNumber}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>GST Number</h6>
                                                      <p>{selectedPolygon.gsT_NO}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Scheme Type</h6>
                                                      <p>{selectedPolygon.userTypeName}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Under Scheme</h6>
                                                      <p>{selectedPolygon.underSchemeName}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Component Name</h6>
                                                      <p>{selectedPolygon.componentName}</p>
                                                  </div>
                                                  <div className="col-md-3 mb-3">
                                                      <h6>Created Date</h6>
                                                      <p>{selectedPolygon.createdOn ? selectedPolygon.createdOn.split('T')[0] : 'N/A'}</p>
                                                  </div>
                                              </div>
      
                                              <h6 className="mb-3 mt-3"><strong>CHC Images</strong></h6>
                                              <div className="row surveydetailsbg">
                                                  {parseImagePaths(selectedPolygon.imagePath).length > 0 ? (
                                                      parseImagePaths(selectedPolygon.imagePath).map((imagePath, index) => (
                                                          <div className="col-md-4 mb-3" key={`${imagePath}-${index}`}>
                                                              <img
                                                                  src={imagePath}
                                                                  alt={`CHC ${index + 1}`}
                                                                  style={{ width: '100%', maxHeight: '220px', objectFit: 'cover', borderRadius: '6px' }}
                                                                  onError={(e) => {
                                                                      e.target.onerror = null;
                                                                      e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="260" height="180"><rect width="100%" height="100%" fill="%23f2f2f2"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="%23999" font-size="14">Image not available</text></svg>';
                                                                  }}
                                                              />
                                                          </div>
                                                      ))
                                                  ) : (
                                                      <div className="col-12">
                                                          <p className="mb-0">No image available</p>
                                                      </div>
                                                  )}
                                              </div>
                                          </div>
                                      </div>
                                      
                                      <div className="modal-footer">
                                          <button type="button" className="btn btn-secondary" onClick={closePolygonModal}>Close</button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      )}
        </>
    );
};


export default IndividualCrmSurvey;

 